import { sendBlogEvent } from '../analytics.js';

const THRESHOLDS = [25, 50, 75, 100];

export function initScrollDepth() {
  const contentEl = document.querySelector('.gh-content');
  if (!contentEl) return;

  const fired = new Set();
  let queued = false;
  let contentTop = 0;
  let contentHeight = 0;

  function measure() {
    const rect = contentEl.getBoundingClientRect();
    contentHeight = rect.height;
    contentTop = rect.top + window.scrollY;
  }

  function contentReadPercent() {
    const viewportHeight = window.innerHeight;
    if (contentHeight <= viewportHeight) return 100;
    const scrollBottom = window.scrollY + viewportHeight;
    const readPixels = Math.max(0, Math.min(scrollBottom, contentTop + contentHeight) - contentTop);
    return Math.min(100, Math.round((readPixels / contentHeight) * 100));
  }

  function check() {
    queued = false;
    const pct = contentReadPercent();
    for (const threshold of THRESHOLDS) {
      if (pct >= threshold && !fired.has(threshold)) {
        fired.add(threshold);
        sendBlogEvent('scroll_depth', { percent: threshold });
      }
    }
    if (fired.size === THRESHOLDS.length) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    }
  }

  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(check);
  }

  function onResize() {
    measure();
    onScroll();
  }

  measure();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
  check();
}
